import React, { useEffect } from "react";
import Header from "../Components/Header";
import Newsletter from "../Components/Newsletter";
import Footer from "../Components/Footer";
import TeamData from "./TeamData.json";
import { Link } from "react-router-dom";

function AdvisoryBoard() {
  var BreadCrumbTitle = "Advisory Board :: D-Right Technologies";
  document.title = BreadCrumbTitle;

  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  const advisors = TeamData.advisory_board || [];

  return (
    <>
      <Header />
      <div className="main">
        <section
          className="page-header-section ptb-100 bg-image"
          image-overlay="8"
        >
          <div
            className="background-image-wraper"
            style={{
              background: `url('assets/img/slider-bg-1.jpg')`,
              opacity: "1",
            }}
          ></div>
          <div className="container">
            <div className="row align-items-center">
              <div className="col-md-9 col-lg-7">
                <div className="page-header-content text-white pt-4">
                  <h1 className="text-white mb-0">Advisory Board</h1>
                </div>
              </div>
            </div>
          </div>
        </section>

        <div className="breadcrumb-bar gray-light-bg border-bottom">
          <div className="container">
            <div className="row">
              <div className="col-12">
                <div className="custom-breadcrumb">
                  <ol className="breadcrumb pl-0 mb-0 bg-transparent">
                    <li className="breadcrumb-item">
                      <a href="#">Home</a>
                    </li>
                    <li className="breadcrumb-item">
                      <a href="#">Team</a>
                    </li>
                    <li className="breadcrumb-item active">Advisory Board</li>
                  </ol>
                </div>
              </div>
            </div>
          </div>
        </div>

        <section className="team-two-section ptb-100 ">
          <div className="container">
            <div className="row">
              {advisors.map((advisor, index) => (
                <div className="col-md-6 col-lg-3" key={index}>
                  <div className="single-team-wrap bg-white text-center border rounded p-4 my-3">
                    <img
                      src={advisor.image}
                      alt={advisor.name}
                      width="120"
                      className="img-fluid m-auto pb-4"
                    />
                    <div className="team-content">
                      <h5 className="mb-0">{advisor.name}</h5>
                      <span>{advisor.role}</span>
                      <p className="mt-3">{advisor.description}</p>

                      {/* No detail page for advisory board for now – commented out
                      <Link
                        to={`/team/detail/${advisor.slug}`}
                        className="btn btn-brand-02 btn-sm mt-2"
                      >
                        View Profile
                      </Link>
                      */}
                    </div>
                  </div>
                </div>
              ))}
              {advisors.length === 0 && (
                <div className="col-12">
                  <div className="text-center">
                    <h5 className="mb-0">No advisory members found.</h5>
                  </div>
                </div>
              )}
            </div>
          </div>
        </section>
      </div>

      <Newsletter />
      <Footer />
    </>
  );
}

export default AdvisoryBoard;
